import { render } from "./ModalLogin.vue?vue&type=template&id=49b4b638&scoped=true"
import script from "./ModalLogin.vue?vue&type=script&lang=js"
export * from "./ModalLogin.vue?vue&type=script&lang=js"

import "./ModalLogin.vue?vue&type=style&index=0&id=49b4b638&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b4b638"]])

export default __exports__